import { RougeDataSets } from '../../data/rouge-data-sets.js';
import { dtoToRgObject } from '../rg-object/dto-to-rg-object.js';

function dtoToRgBrief(dto) {
    const brief = {
        dataset: RougeDataSets[dto.obj.data.dataset],
        obj: dtoToRgObject(dto.obj),
        zoneBriefs: structuredClone(dto.zoneBriefs),
        face2FaceSeparation: dto.face2FaceSeparation,
        face2SideSeparation: dto.face2SideSeparation,
        optimisePlots: dto.optimisePlots
    };
    return brief;
}

export { dtoToRgBrief };
//# sourceMappingURL=dto-to-rg-brief.js.map
